/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateEventSettingsRequest } from './update-event-settings-request';


export interface UpdateEventSettingRequest { 
    equipmentId: string;
    eventSettings: Array<UpdateEventSettingsRequest>;
}

